// extracted by mini-css-extract-plugin
module.exports = {"close":"menu-mobile-header_close__wfz6z","header":"menu-mobile-header_header__M47pk","logo":"menu-mobile-header_logo__VsCMW"};